module.exports = __webpack_public_path__ + "img/local-two.0768cc3a.svg";